<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div class="mt-1" v-else>
             <v-slide-x-reverse-transition>
                <v-alert type="error" class="alert_all_page" v-if="alert_error === true">{{ alert_message_error }}</v-alert>
                <v-alert type="success" class="alert_all_page" v-if="alert_success === true">{{ alert_message_success }}</v-alert>
            </v-slide-x-reverse-transition>
            <v-row >
                <v-col xs="12" sm="12" md="9" lg="10" xl="10" cols="12">
                    <div class="title_page ma-3">
                        <h4 class="breadcrumb_title_page">แก้ไข Tax Refund</h4>
                        <v-breadcrumbs :items="sub_menu">
                            <template v-slot:divider>
                            <v-icon>mdi-chevron-right</v-icon>
                            </template>
                        </v-breadcrumbs>
                    </div>
                </v-col>
                <v-col xs="12" sm="12" md="3" lg="2" xl="2" cols="12">
                    <div class="title_page ma-3">
                        <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()" large>ย้อนกลับ</v-btn>
                    </div>
                </v-col>
                
            </v-row>
            <div class="mt-1">
                <v-card elevation="3" class="pa-5 " style="border-radius: 15px;">
                    <section class="pa-3">
                        <v-form ref="setting" @submit.prevent="saveData()">
                            <v-row>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="d-flex">
                                    <div class="title_form_main">
                                        <div class="logo_timeline">
                                            <img src="@/assets/arin_assets/avatar_white.png">
                                        </div>
                                    </div>
                                    <div class="header-content py-1 pl-5 pr-5 text-center">
                                        <div class="content-font">ข้อมูลใบเสร็จ</div>
                                    </div>
                                    </div>
                                </v-col>
                            </v-row>
                            
                            <v-row class="pl-5">
                                <v-col xs="6" sm="6" md="4" lg="4" xl="4" cols="6" class="pa-3 py-2 pb-4 ">
                                    <div class="text_title mt-2">เลขที่ใบเสร็จ : {{ data_list.invoice_code }}</div>
                                </v-col>
                                <v-col v-if="refund_inv_date != ''" xs="12" sm="6" md="8" lg="8" xl="8" cols="12" class="pa-3 py-2 pb-4  ">
                                    <div class="font-18 mt-2">วันที่เอกสาร : {{ diffDateTH_Departure(data_list.doc_date) }}</div>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="d-flex">
                                        <div class="title_form_main">
                                            <div class="logo_timeline">
                                                <img src="@/assets/arin_assets/box.png">
                                            </div>
                                        </div>
                                        <div class="header-content py-1 pl-5 pr-5 text-center">
                                            <div class="content-font">ข้อมูลใบ tax Refund</div>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                            
                            <v-row class="pl-5">
                                <v-col cols="12" xl="6" lg="6" md="12" sm="12" >
                                    <v-card :loading="loading" class="mx-auto my-6 input-radius">
                                        <template slot="progress">
                                            <v-progress-linear
                                                color="deep-purple"
                                                height="10"
                                                indeterminate
                                            ></v-progress-linear>
                                        </template>

                                        <v-card-title class="font-16 py-1 text-center bold header_card">
                                            FOR RETAILER :
                                        </v-card-title>

                                       <v-card-text>
                                            <v-row>
                                                <v-col class="my-3 mb-0">
                                                    <div class="font-18 sub_header">สำหรับผู้ขาย</div>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="8" class="pb-2">
                                                    <div class="font-16"> <span class="text-grey"> เลขประจำตัวผู้เสียภาษีอากร :</span> {{seller.store_personal_id}}</div>
                                                </v-col>
                                                <v-col cols="4" class="pb-2">
                                                    <div class="font-16"> <span class="text-grey"> สาขาที่ : </span> {{ seller.store_code != null ? seller.store_code : '-'}}</div>
                                                </v-col>
                                                <v-col cols="12 pt-0 pb-2">
                                                    <div class="font-16"> <span class="text-grey"> ชื่อผู้ประกอบการ : </span>  {{seller.status_main_store == 1 ? 'บริษัท ฟาร์มาแคร์ พลัส จำกัด' : seller.store_name}} </div>
                                                </v-col>
                                                <v-col cols="12 pt-0 pb-2">
                                                    <div class="font-16"> 
                                                        <span class="text-grey">  สถานประกอบการที่จัดทำ ภ.พ.10 เลขที่ :  </span> 
                                                        <div class="mt-1 line-h"> {{seller.address}} {{seller.address_list}}</div>
                                                    </div>
                                                </v-col> 
                                                <v-col cols="12 pt-0">
                                                    <div class="font-16"> <span class="text-grey">  โทรศัพท์ :  </span> {{seller.tel}}</div>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col>
                                                    <v-simple-table fixed-header height="400px" class="border-grey">
                                                        <template v-slot:default>
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-center" width="50">
                                                                        <div>ITEMS</div>
                                                                        <div class="text-grey">รายการ</div>
                                                                    </th>
                                                                    <th class="text-center">
                                                                        <div> Description of goods</div>
                                                                        <div class="text-grey"> รายการสินค้า</div>
                                                                    </th>
                                                                    <th class="text-center" width="80">
                                                                        <div>Quantity</div>
                                                                        <div class="text-grey">จำนวน</div>
                                                                    </th>
                                                                    <th class="text-center" width="160">
                                                                        <div> Price (Vat included) </div>
                                                                        <div class="text-grey"> ราคา (รวมภาษีมูลค่าเพิ่ม) </div>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(item, index) in data_list.product_list" :key="index" >
                                                                    <td class="text-center border-empty">{{ index+1 }}</td>
                                                                    <td class="border-empty">{{ item.product_name }}</td>
                                                                    <td class="text-center border-empty">{{ parseInt(item.qty) }}</td>
                                                                    <td class="text-right border-empty">{{ formatPrice(item.total) }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>

                                        <v-card-title class="line-h-0">
                                            <v-row>
                                                <v-col cols="12" lg="4" xl="4"></v-col>
                                                <v-col class="font-16" cols="7" lg="5" xl="5" >
                                                   <div>Total Payment </div>
                                                   <div class="text-grey">จำนวนเงิน</div>
                                                </v-col>
                                                <v-col class="font-16" cols="5" lg="3" xl="3">{{formatPrice(data_list.total_payment)}}</v-col>
                                                <!-- <v-col v-else class="font-16" cols="5" lg="3" xl="3">{{formatPrice(parseFloat(data_list.total_payment) + (parseFloat(parseFloat(data_list.total_payment) * (parseFloat(seller.credit_charge_status) == 1 ? parseFloat(seller.credit_charge) / 100 : 0))))}}</v-col> -->
                                                <v-col cols="12 py-0" lg="4" xl="4"></v-col>
                                                <v-col class="font-16" cols="7" lg="5" xl="5">
                                                    <div>Total VAT</div>
                                                    <div class="text-grey">จำนวนเงินภาษีมูลค่าเพิ่ม</div>
                                                </v-col>
                                                <v-col class="font-16" cols="5" lg="3" xl="3">{{formatPrice(data_list.total_vat)}}</v-col>
                                                 <!-- <v-col v-if="data_list.pay_type.find(o => o === 3)" cols="12 py-0" lg="4" xl="4"></v-col>
                                                <v-col v-if="data_list.pay_type.find(o => o === 3)" class="font-16" cols="7" lg="5" xl="5">
                                                    <div>Credit Charge {{parseFloat(seller.credit_charge)}} %</div>
                                                    <div class="text-grey">จำนวนเงินภาษีเครดิตมูลค่าเพิ่ม</div>
                                                </v-col>
                                                <v-col v-if="data_list.pay_type.find(o => o === 3)" class="font-16" cols="5" lg="3" xl="3">{{formatPrice((parseFloat(parseFloat(data_list.total_payment) * (parseFloat(seller.credit_charge_status) == 1 ? parseFloat(seller.credit_charge) / 100 : 0))))}}</v-col> -->
                                                <v-col cols="12 py-0" lg="4" xl="4"></v-col>
                                                <v-col class="font-16" cols="7" lg="5" xl="5">
                                                    <div> Total VAT/Refundable</div>
                                                    <div class="text-grey">จำนวนเงินภาษีมูลค่าเพิ่มที่ขอคืน</div>
                                                </v-col>
                                                <v-col class="font-16" cols="5" lg="3" xl="3">{{formatPrice(data_list.total_vat_refund)}}</v-col>
                                            </v-row>
                                        </v-card-title>

                                    </v-card>

                                </v-col>

                                <v-col cols="12" xl="6" lg="6" md="12" sm="12" >
                                    <v-card :loading="loading" class="mx-auto my-6 input-radius">
                                        <template slot="progress">
                                            <v-progress-linear
                                                color="deep-purple"
                                                height="10"
                                                indeterminate
                                            ></v-progress-linear>
                                        </template>

                                        <v-card-title class="header_card font-16 py-1 text-center bold">FOR TOURIST :</v-card-title>

                                        <v-card-text>
                                            <v-row>
                                                <v-col class="my-3 mb-0">
                                                    <div class="font-18 sub_header">สำหรับนักท่องเที่ยว (กรอกข้อมูลเป็นภาษาอังกฤษเท่านั้น)</div>
                                                </v-col>
                                            </v-row>
                                            
                                            <v-row>
                                                <v-col cols="12 pt-2">
                                                    <v-form-group>
                                                        <label class="label_form_text">ชื่อนักท่องเที่ยว/Name of Tourist/Claimant <span class="required--text">*</span></label>
                                                        <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-account" maxlength="100"                                                       hide-details="auto" :rules="[v => !!v || 'กรุณากรอกข้อมูล']" v-model="data_list.tourist_name" @keypress="OnlyENGCharacter($event, data_list.tourist_name)"
                                                        placeholder="กรุณากรอกชื่อนักท่องเที่ยว" single-line outlined dense required></v-text-field>
                                                    </v-form-group>
                                                </v-col>
                                                <v-col cols="12 pt-2">
                                                    <v-form-group>
                                                        <label class="label_form_text">สัญชาติ/Nationality <span class="required--text">*</span></label>
                                                        <v-autocomplete color="#D6BFAF" class="input-radius" v-model="data_list.nationlity_id" :items="national_list" item-text="nationality" item-value="id" :rules="[v => !!v || 'กรุณาเลือกสัญชาติ']" hide-details="auto" label="กรุณาเลือกสัญชาติ"   clearable required outlined dense deletable-chips></v-autocomplete>
                                                    </v-form-group>
                                                </v-col>
                                                <v-col cols="12 pt-2">
                                                    <v-form-group>
                                                        <label class="label_form_text">เลขที่หนังสือเดินทาง/Passport No. <span class="required--text">*</span></label>
                                                        <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-book-account" maxlength="100"
                                                        hide-details="auto" :rules="[v => !!v || 'กรุณากรอกข้อมูล']" v-model="data_list.passport_no" @keypress="OnlyENGCharacter($event, data_list.passport_no)"
                                                        placeholder="กรุณากรอกเลขที่หนังสือเดินทาง" single-line outlined dense required></v-text-field>
                                                    </v-form-group>
                                                </v-col>

                                                <v-col cols="12 pt-2" md="6" lg="6" sl="6">
                                                    <v-form-group>
                                                        <label class="label_form_text">วันที่เดินทางถึง/Arrival Date </label>
                                                        <v-menu ref="refund_arrival_menu_date" v-model="data_list.refund_arrival_menu_date" @click="refund_arrival_menu_date=!refund_arrival_menu_date" transition="scale-transition" offset-y min-width="auto">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-text-field class="input-radius" placeholder="กรุณาเลือกวันที่เดินทางถึง" color="" v-model="data_list.arrival_date" label="" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined dense hide-details></v-text-field>
                                                            </template>
                                                            <v-date-picker  color="#D6BFAF" v-model="data_list.arrival_date" dense ></v-date-picker>
                                                        </v-menu>
                                                    </v-form-group>
                                                </v-col>

                                                <v-col cols="12 pt-2" md="6" lg="6" sl="6">
                                                    <v-form-group>
                                                        <label class="label_form_text">วันที่เดินทางออก/Departure Date </label>
                                                        <v-menu ref="refund_departure_menu_date" v-model="data_list.refund_departure_menu_date" @click="refund_departure_menu_date=!refund_departure_menu_date" transition="scale-transition" offset-y min-width="auto">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-text-field class="input-radius" placeholder="กรุณาเลือกวันที่เดินทางออก" color="" v-model="data_list.departure_date" label="" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined dense hide-details></v-text-field>
                                                            </template>
                                                            <v-date-picker  color="#D6BFAF" v-model="data_list.departure_date" dense ></v-date-picker>
                                                        </v-menu>
                                                    </v-form-group>
                                                </v-col>

                                                <v-col cols="12 pt-2">
                                                    <v-form-group>
                                                        <label class="label_form_text">เลขที่เที่ยวบิน/Flight No. </label>
                                                        <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-airplane"
                                                        hide-details="auto" v-model="data_list.flight_no" @keypress="OnlyENGCharacter($event, data_list.flight_no)" maxlength="100"
                                                        placeholder="กรุณากรอกเลขที่เที่ยวบิน" single-line outlined dense></v-text-field>
                                                    </v-form-group>
                                                </v-col>
                                                <v-col cols="12 pt-2">
                                                    <v-form-group>
                                                        <label class="label_form_text">ที่อยู่ในต่างประเทศ/Permanent/Mailing Address </label>
                                                        <v-textarea class="input-radius" placeholder="กรุณากรอกที่อยู่ต่างประเทศ" auto-grow hide-details outlined rows="3" row-height="25" v-model="data_list.address" @keypress="OnlyENGCharacter($event, data_list.address)" maxlength="255"></v-textarea>
                                                    </v-form-group>
                                                </v-col>

                                                <v-col cols="12 pt-2" md="6" lg="6" sl="6">
                                                    <v-form-group>
                                                        <label class="label_form_text">รหัสไปรษณีย์/Postcode </label>
                                                        <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-map-marker"
                                                        hide-details="auto" v-model="data_list.postcode" @keypress="isNumber($event, data_list.postcode)"
                                                        placeholder="กรุณากรอกรหัสไปรษณีย์" single-line outlined dense></v-text-field>
                                                    </v-form-group>
                                                </v-col>

                                                <v-col cols="12 pt-2" md="6" lg="6" sl="6">
                                                    <v-form-group>
                                                        <label class="label_form_text">เมือง/City </label>
                                                        <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-city"
                                                        hide-details="auto" v-model="data_list.city" @keypress="OnlyENGCharacter($event, data_list.city)" maxlength="100"
                                                        placeholder="กรุณากรอกชื่อเมือง" single-line outlined dense></v-text-field>
                                                    </v-form-group>
                                                </v-col>

                                                <v-col cols="12 pt-2" md="6" lg="6" sl="6">
                                                    <v-form-group>
                                                        <label class="label_form_text">ประเทศ/Country </label>
                                                        <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-flag"
                                                        hide-details="auto" v-model="data_list.country" @keypress="OnlyENGCharacter($event, data_list.country)" maxlength="100"
                                                        placeholder="กรุณากรอกประเทศ" single-line outlined dense></v-text-field>
                                                    </v-form-group>
                                                </v-col>

                                                <v-col cols="12 pt-2" md="6" lg="6" sl="6">
                                                    <v-form-group>
                                                        <label class="label_form_text">อีเมล/Email </label>
                                                        <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-email" maxlength="100"
                                                        hide-details="auto" v-model="data_list.email" @keypress="validateEmail($event, data_list.email)" type="email"
                                                        placeholder="กรุณากรอกอีเมล" single-line outlined dense></v-text-field>
                                                    </v-form-group>
                                                </v-col>

                                                <v-col cols="12 pb-0">
                                                    <div class="font-16 bold">Refund to be receives in one of the following forms</div>
                                                    <div class="font-16 text-grey"> ข้าพเจ้าประสงค์จะขอรับคืนเงินภาษี เป็น</div>
                                                </v-col>
                                                <v-radio-group v-model="data_list.refund_type">
                                                <v-col cols="12 title_page_end py-0">
                                                    <v-radio class="pt-0" color="orange" value="0"></v-radio>
                                                    <div class="grid font-16">Cash in Thai baht (in case that the refund is not exceeding 30,000 baht)
                                                        <span class="text-grey">เงินสด (ในกรณีขอคืนภาษีไม่เกิน 30,000 บาท)</span>
                                                    </div>
                                                </v-col>

                                                <v-col cols="12 title_page_end py-0">
                                                    <v-radio class="pt-0" color="orange" indeterminate value="1"></v-radio>
                                                    <div class="grid font-16 ">Draft
                                                        <span class="text-grey">ดราฟต์</span>
                                                    </div>
                                                </v-col>

                                                <v-row v-if="data_list.refund_type == '1'">
                                                    <v-radio-group v-model="data_list.draft_type">
                                                    <v-row>
                                                        <v-col cols="auto">
                                                    <v-radio value="0" class="pa-0 ma-0 pl-7 font-16" label="USD" color="orange" hide-details indeterminate></v-radio>
                                                </v-col>
                                                <v-col cols="auto">
                                                    <v-radio value="1" class="pa-0 ma-0 pl-7 font-16" label="Euro" color="orange" hide-details indeterminate></v-radio>
                                                </v-col>
                                                <v-col cols="auto">
                                                    <v-radio value="2" class="pa-0 ma-0 pl-7 font-16" label="Yen" color="orange" hide-details indeterminate></v-radio>
                                                </v-col>
                                                <v-col cols="auto">
                                                    <v-radio value="3" class="pa-0 ma-0 pl-7 font-16" label="Pound Sterling" color="orange" hide-details indeterminate></v-radio>
                                                </v-col>
                                                    </v-row>
                                                </v-radio-group>
                                                </v-row>

                                                <v-col cols="12 title_page_end py-0">
                                                    <v-radio class="pt-0" color="orange" indeterminate value="2"></v-radio>
                                                    <div class="grid font-16">  Credit Card (Must be the same as that of the claimant)
                                                        <span class="text-grey">บัตรเครดิต</span>
                                                    </div>
                                                </v-col>

                                               <v-row v-if="data_list.refund_type == '2'">
                                                 <v-radio-group v-model="data_list.credit_type">
                                                 <v-row>
                                                    <v-col cols="auto">
                                                    <v-radio value="0" class="pa-0 ma-0 pl-7 font-16" label="VISA" color="orange" hide-details indeterminate></v-radio>
                                                </v-col>
                                                <v-col cols="auto">
                                                    <v-radio value="1" class="pa-0 ma-0 pl-7 font-16" label="Dinners" color="orange" hide-details indeterminate></v-radio>
                                                </v-col>
                                                <v-col cols="auto">
                                                    <v-radio value="2" class="pa-0 ma-0 pl-7 font-16" label="JCB" color="orange" hide-details indeterminate></v-radio>
                                                </v-col>
                                                <v-col cols="auto">
                                                    <v-radio value="3" class="pa-0 ma-0 pl-7 font-16" label="Master Card" color="orange" hide-details indeterminate></v-radio>
                                                </v-col>
                                                 </v-row>
                                                 </v-radio-group>
                                               </v-row>
                                                </v-radio-group>
                                                <v-col cols="12 pt-2" md="12" lg="12" sl="12" class="pl-10 " v-if="data_list.refund_type == '2'">
                                                    <v-form-group>
                                                        <label class="label_form_text">ชื่อบนบัตร/Name of credit cardholder </label>
                                                        <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-account"
                                                        hide-details="auto" :rules="[v => !!v || 'กรุณากรอกข้อมูล']" v-model="data_list.name_of_credit" @keypress="OnlyENGCharacter($event, data_list.name_of_credit)" maxlength="100"
                                                        placeholder="กรุณากรอกชื่อบนบัตร" single-line outlined dense required></v-text-field>
                                                    </v-form-group>
                                                </v-col>
                                                <v-col cols="12 pt-2" md="12" lg="12" sl="12" class="pl-10 " v-if="data_list.refund_type == '2'">
                                                    <v-form-group>
                                                        <label class="label_form_text">เลขที่บัตร/card No. (Should not expire in the next 6 months) </label>
                                                        <v-otp-input class="mh-40" length="16" type="text" placeholder="x" outlined dense v-model="data_list.card_no" @keypress="isCreditNumber($event, data_list.card_no)"></v-otp-input>
                                                    </v-form-group>
                                                    
                                                </v-col>
                                                <v-col cols="12 pt-2" md="12" lg="12" sl="12" class="pl-10 " v-if="data_list.refund_type == '2'">
                                                    <v-form-group>
                                                        <label class="label_form_text">หมดอายุวันที่/Expiry Date </label>
                                                        <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-clock-alert"
                                                        hide-details="auto" :rules="[v => !!v || 'กรุณากรอกข้อมูล']" v-model="data_list.expiry_date" maxlength="100"
                                                        placeholder="กรุณากรอกหมดอายุวันที่" single-line outlined dense required></v-text-field>
                                                    </v-form-group>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>

                                    </v-card>

                                </v-col>
                            </v-row>

                            <div class="text-center mt-6 mb-3">
                                <v-btn type="submit" height="45" width="150" class="white--text grad-success-arin-bg mobile_btn" style="font-size: 18px; border-radius: 10px;">บันทึก</v-btn>
                            </div>
                        </v-form>
                    </section>
                </v-card>
            </div>
        </div>
    </div>
</template>
  
<script>
import { formatPrice, OnlyENGCharacter, isTelephone, validateEmail, isCreditNumber } from "@/js/handler";
import { HTTP_ARIN } from "@/axios_arin";
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Pos_invoices_tax_refund_edit",
    data() {
        return {
            loading_page: false,
            alert_error:false,
            alert_message_error:null,
            alert_success:false,
            alert_message_success:null,
            dialog_cancel_order: false,
            
            footer_Props:{
                'items-per-page-text':'รายการต่อหน้า'
            },

            data_list: {
                total_payment: 0,
                total_vat: 0,
                total_vat_refund: 0,
                pay_type: []
            },
            sub_menu:[
                {
                    text:'ระบบ POS',
                    disabled:false,
                },
                {
                    text:'การขาย',
                    disabled:false,
                },
                {
                    text:'ใบ Tax Refund',
                    disabled:false,
                },
                {
                    text:'แก้ไขใบ Tax Refund',
                    disabled:false,
                },
            ],
            seller: {
                pay_type: [],
                credit_charge_status: null,
                credit_charge: null,
            },
            national_list:[]
        }
    }, methods: {
        validateEmail(value){
            return validateEmail(value)
        },
        isNumber: function (evt, number){
            return isTelephone(evt, number)
        },
        isCreditNumber: function (evt, number){
            return isCreditNumber(evt, number)
        },
        OnlyENGCharacter(value){
            return OnlyENGCharacter(value)
        },
        formatPrice(number){
            return formatPrice(number)
        },
        diffDateTH_Arrival(value){
            const diff = value.split('-')
            const day = diff[2]
            const month = diff[1]
            const year = parseInt(diff[0])+543
            const final_date = day+'/'+month+'/'+year
            return final_date
        },

        diffDateTH_Departure(value){
            const diff = value.split('-')
            const day = diff[2]
            const month = diff[1]
            const year = parseInt(diff[0])+543
            const final_date = day+'/'+month+'/'+year
            return final_date
        },
         async getTaxRefundDetail(){
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            }
            let id = this.$route.params.id;
            await HTTP_ARIN.get('/tax/refund/'+id, config).then((res) => {
                if (res.data.successful === true) {
                    this.data_list = res.data.data;
                    this.data_list = {
                            ...this.data_list,
                            refund_type: this.data_list.refund_type != null ? this.data_list.refund_type+'' : null,
                            draft_type: this.data_list.draft_type != null ? this.data_list.draft_type+'' : null,
                            credit_type: this.data_list.credit_type != null ? this.data_list.credit_type+'' : null,
                           
                        }
                    this.getStoreDetail()
                    this.getNationalToSelectbox(this.data_list.nationlity_id)
                }
            })
         },
         async getStoreDetail(){
                     let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            }
            let store_id = this.$store.state.store_arin.user_data.store_id;
            await HTTP_ARIN.get('/stores/detail/' + store_id, config).then((res) => {
                if (res.data.successful === true) {
                    this.seller = res.data.storeDetail;
                    this.seller.credit_charge_status = this.data_list.credit_charge_status;
                    this.seller.credit_charge = this.data_list.credit_charge;
                }
            })
         },
         async getNationalToSelectbox(){
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            }
            await HTTP_ARIN.get('/tax/refund/nationality', config).then((res) => {
                if (res.data.successful === true) {
                    this.national_list = res.data.data
                        
                  
                }
            })
         },
          async saveData(){
           if(this.$refs.setting.validate()){
                 let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            } 
            let data = {
                id: this.$route.params.id,
                invoice_id: this.data_list.invoice_id,
                doc_date: this.data_list.doc_date,
                total_payment: this.data_list.total_payment,
                total_vat: this.data_list.total_vat,
                total_vat_refund: this.data_list.total_vat_refund,
                tourist_name: this.data_list.tourist_name,
                nationlity_id: this.data_list.nationlity_id,
                passport_no: this.data_list.passport_no,
                arrival_date: this.data_list.arrival_date,
                departure_date: this.data_list.departure_date,
                flight_no: this.data_list.flight_no,
                address: this.data_list.address,
                postcode: this.data_list.postcode,
                city: this.data_list.city,
                country: this.data_list.country,
                email: this.data_list.email,
                refund_type: this.data_list.refund_type,
                draft_type: this.data_list.refund_type == '1' ? this.data_list.draft_type : null,
                credit_type: this.data_list.refund_type == '2' ? this.data_list.credit_type : null,
                name_of_credit: this.data_list.refund_type == '2' ? this.data_list.name_of_credit : null,
                card_no: this.data_list.refund_type == '2' ? this.data_list.card_no : null,
                expiry_date: this.data_list.refund_type == '2' ? this.data_list.expiry_date : null
            }
            await HTTP_ARIN.post('/tax/refund/edit', data, config).then((res) => {
                if (res.data.successful === true) {
                   this.alert_success = true
                    this.alert_message_success = 'แก้ไขใบ Tax Refund สำเร็จ'
                    setTimeout(() => {this.alert_success = false; this.$router.push('/arin/pos/posinvoicestaxrefund')}, 3000) 
                }
            })
           }
         },
    },
    mounted(){
        this.getTaxRefundDetail()
        this.getNationalToSelectbox()
    }
}
</script>
  
<style scoped>
.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  /* width: 100%; */
}

.header_card{
    border: 1px solid #D6BFAF;
    border-radius: 10px;
    color: #D6BFAF;
    background-color: #fbf9f7;
    display: flex;
    justify-content: center;
}

.sub_header{
    border-bottom: 1px solid #D9D9D9;
    display: inline;
}

.line-h{
    line-height: 25px;
}

.line-h-0{
    line-height: 1.5rem !important;
}

.mh-40
{
    min-height: 40px !important;
}

.border-grey
{
    border-bottom: 1px solid #e0e0e0;
}
.border-empty{
    border-bottom: 0px !important;
}



</style>
  